"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_CAMPAIGN_SESSION_ID = exports.SENTRY_PROJECT_ID = exports.questEntityId = exports.STAGING_URL = exports.PRODUCTION_URL = void 0;
exports.PRODUCTION_URL = "https://api.questera.ai/api";
exports.STAGING_URL = "https://staging-api.questera.ai/api";
exports.questEntityId = "e-0000000000";
exports.SENTRY_PROJECT_ID = "https://8ee118168877cbbe20242e6a180504b6@o1016721.ingest.sentry.io/4506304794263552";
exports.TEXT_CAMPAIGN_SESSION_ID = "quest-text-campaign-session-id";
